module.exports = __webpack_public_path__ + "img/cwm-logo-fr_white@legacy.0c152ac7.svg";